export function number(value: number) {
    return Number(value.toPrecision(15));
}
